const BuildingIcon = ({ className }: any) => {
  return (
    <svg className={`text-mainGray ${className}`} width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.49651 4.99609H14.5007C15.0532 4.99609 15.5011 5.444 15.5011 5.99651V21.0028H4.49651C3.944 21.0028 3.49609 20.5549 3.49609 20.0023V5.99651C3.49609 5.444 3.944 4.99609 4.49651 4.99609Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path fillRule="evenodd" clipRule="evenodd" d="M15.5039 8.99805H20.506C21.0585 8.99805 21.5064 9.44595 21.5064 9.99846V20.0026C21.5064 20.5551 21.0585 21.003 20.506 21.003H15.5039V8.99805Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M7.50021 8.8732C7.43114 8.8732 7.37516 8.92919 7.37516 8.99826C7.37516 9.06732 7.43114 9.12331 7.50021 9.12331C7.56927 9.12331 7.62526 9.06732 7.62526 8.99826C7.62526 8.92919 7.56927 8.8732 7.50021 8.8732"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5002 8.8732C11.4311 8.8732 11.3752 8.92919 11.3752 8.99826C11.3752 9.06732 11.4311 9.12331 11.5002 9.12331C11.5693 9.12331 11.6253 9.06732 11.6253 8.99826C11.6253 8.92919 11.5693 8.8732 11.5002 8.8732"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.50021 12.8732C7.43114 12.8732 7.37516 12.9292 7.37516 12.9983C7.37516 13.0673 7.43114 13.1233 7.50021 13.1233C7.56927 13.1233 7.62526 13.0673 7.62526 12.9983C7.62526 12.9292 7.56927 12.8732 7.50021 12.8732"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5002 12.8732C11.4311 12.8732 11.3752 12.9292 11.3752 12.9983C11.3752 13.0673 11.4311 13.1233 11.5002 13.1233C11.5693 13.1233 11.6253 13.0673 11.6253 12.9983C11.6253 12.9292 11.5693 12.8732 11.5002 12.8732"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.50021 16.8752C7.43114 16.8752 7.37516 16.9311 7.37516 17.0002C7.37516 17.0693 7.43114 17.1253 7.50021 17.1253C7.56927 17.1253 7.62526 17.0693 7.62526 17.0002C7.62526 16.9311 7.56927 16.8752 7.50021 16.8752"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5002 16.8752C11.4311 16.8752 11.3752 16.9311 11.3752 17.0002C11.3752 17.0693 11.4311 17.1253 11.5002 17.1253C11.5693 17.1253 11.6253 17.0693 11.6253 17.0002C11.6253 16.9311 11.5693 16.8752 11.5002 16.8752"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5041 12.8732C18.4351 12.8732 18.3791 12.9292 18.3791 12.9983C18.3791 13.0673 18.4351 13.1233 18.5041 13.1233C18.5732 13.1233 18.6292 13.0673 18.6292 12.9983C18.6292 12.9292 18.5732 12.8732 18.5041 12.8732"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5041 16.8752C18.4351 16.8752 18.3791 16.9311 18.3791 17.0002C18.3791 17.0693 18.4351 17.1253 18.5041 17.1253C18.5732 17.1253 18.6292 17.0693 18.6292 17.0002C18.6292 16.9311 18.5732 16.8752 18.5041 16.8752"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BuildingIcon;
